<template>
  <div
    class="d-flex flex-column justify-content-between align-items-center wc-item-detail font-size-xs"
  >
    <div>
      <a class="underline-link-from-center font-size-xs" :href="`i/${lineItem.item.id}`">{{
        lineItem.item.name
      }}</a>
    </div>
    <a :href="`i/${lineItem.item.id}`">
      <WCImage
        :imageSrc="getProductImage(lineItem.item.image)"
        :imageAlt="productImgAltText(lineItem.item.name, lineItem.item.brand)"
        imageClass="wc-item-image"
        defaultClass="wc-icon-wrapper mx-auto font-size-5xl"
        :defaultTitle="noProductImageAltText(lineItem.item.name)"
      />
    </a>
    <div class="d-flex align-items-end">
      <WCProductPricing v-if="lineItem.item" :item="lineItem.item" class="mr-3" />
      <span>{{ $t('quantityAbbr') }} {{ lineItem.quantity }}</span>
    </div>
  </div>
</template>

<script>
import WCProductPricing from '@/components/WCProductPricing/WCProductPricing.vue';
import ProductImageInfoMixin from '@/mixins/ProductImageInfoMixin';
import WCImage from '@/components/WCImage/WCImage.vue';

export default {
  name: 'WCOrderPanelLineItem',
  components: { WCProductPricing, WCImage },
  mixins: [ProductImageInfoMixin],
  props: {
    lineItem: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-item-image {
  width: rem(50px);
  height: rem(50px);
  object-fit: scale-down;
}

.wc-item-detail {
  min-width: rem(100px);
  max-width: rem(125px);
  min-height: rem(130px);
}
</style>
